<template>
    <div class="app-container mt-5">

        <div class="page-title mb-3">
            <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">list_alt</v-icon> Mon référentiel
                <span v-if="account.tis_type.code === 'APIDAE'">Apidae</span>
            </span>
        </div>

        <referential></referential>
    </div>
</template>

<script>
import Referential from "../../onboard/steps/Referential"
import { mapState } from "vuex"

export default {
    name: "ReferentialConfig",
    components: { Referential },
    computed: {
        ...mapState('account', ['account'])
    }
}
</script>